"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSocialTitleProperty = exports.socialTitlePropertyDefinition = void 0;
exports.socialTitlePropertyDefinition = {
    view: {
        label: 'Social title',
        hint: 'The link\'s title when shared on Facebook (og:title). Make it engaging.',
    },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'social-title',
};
const isSocialTitleProperty = (prop) => {
    return prop.name === exports.socialTitlePropertyDefinition.name;
};
exports.isSocialTitleProperty = isSocialTitleProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29jaWFsLXRpdGxlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvc29jaWFsLXRpdGxlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGNBQWM7UUFDckIsSUFBSSxFQUFFLHlFQUF5RTtLQUNoRjtJQUNELFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxjQUFjO0NBQ1csQ0FBQTtBQUkxQixNQUFNLHFCQUFxQixHQUFHLENBQUMsSUFBa0IsRUFBK0IsRUFBRTtJQUN2RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsscUNBQTZCLENBQUMsSUFBSSxDQUFBO0FBQ3pELENBQUMsQ0FBQTtBQUZZLFFBQUEscUJBQXFCLHlCQUVqQyJ9